import { isAxiosError } from "typeGuards/isAxiosError";
import { isObject } from "typeGuards/isObject";
import { isString } from "typeGuards/isString";
import { getAxiosErrorMessage } from "utils/getAxiosErrorMessage";

export const getDatabaseErrorMessage = (e: unknown): string => {
  const data: unknown = isAxiosError(e) ? e.response?.data : undefined;
  if (isObject(data) && isString(data.message) && data.message) {
    return isString(data.hint) && data.hint
      ? `${data.message}. ${data.hint}`
      : data.message;
  }
  return getAxiosErrorMessage(e);
};
